export const brokenDiscountHandlingValues = {
  noOp: 'no_op',
  chargeFee: 'charge_fee',
}

export const brokenDiscountHandlingOptions = [
  {
    label: 'Usar precio pagado y no cobrar fees',
    description:
      'Se usará el precio pagado originalmente por los productos. No se aplica ninguna tasa aunque la devolución rompa el descuento',
    value: brokenDiscountHandlingValues.noOp,
  },
  {
    label: 'Cobrar una fee por el descuento roto',
    description:
      'Si una devolución rompe las condiciones del descuento, se cobra una tasa para recuperar la bonificación a la que el cliente ya no tiene derecho.',
    value: brokenDiscountHandlingValues.chargeFee,
  },
]
